import React from "react";

export default function MobileMenuIcon({ onClick, className }) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      onClick={onClick}
      viewBox="0 0 24 24"
      className={`w-6 h-6 cursor-pointer ${className}`}
      strokeWidth={1.5}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
      />
    </svg>
  );
}
